"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.healthCheck = void 0;
const typebox_1 = require("@sinclair/typebox");
/**
 * An empty response body type for health check.
 */
// eslint-disable-next-line import/prefer-default-export
exports.healthCheck = typebox_1.Type.Null({
    description: 'health check ok',
});
//# sourceMappingURL=healthCheck.js.map